import React from 'react';
import { Spinner } from 'react-bootstrap';

/**
 * Componente de carga centrado para transiciones entre módulos
 * Se muestra mientras React.lazy carga el chunk del módulo
 */
const LoadingFallback = () => {
    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="text-center">
                <Spinner animation="border" variant="primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
                <p className="mt-3 text-muted fw-medium">Cargando módulo...</p>
            </div>
        </div>
    );
};

export default LoadingFallback;
